// test1069
(1069 && 0);
